import React from 'react';
import { Routes, Route, useNavigate } from "react-router-dom";
import { toast } from 'sonner';
import Students from './Students';
import AddStudents from './AddStudents';
import ViewStudentDetail from './ViewStudentDetail';
import EditStudents from './EditStudents';

const ProtectedRoute = ({ element, permission, fallbackPath = '/dashboard/students' }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!permission) {
      toast.warning("You don't have permission to access this page.");
      navigate(fallbackPath, { replace: true });
    }
  }, [permission, navigate, fallbackPath]);

  return permission ? element : null;
};

const MainStudents = () => {
  const User = JSON.parse(localStorage.getItem("User") || "{}");
  const Permission = User?.userRole?.permissions?.student || {}; // Using 'student' permissions

  return (
    <div className='bg-gray-100 text-gray-900 dark:bg-gray-900 dark:text-white relative'>
      <Routes>
        <Route path='/' element={<Students />} />

        <Route
          path='/add-students'
          element={<ProtectedRoute element={<AddStudents />} permission={Permission.create} />}
        />

        <Route
          path='/view-students'
          element={<ProtectedRoute element={<ViewStudentDetail />} permission={Permission.read} />}
        />

        <Route
          path='/edit-students'
          element={<ProtectedRoute element={<EditStudents />} permission={Permission.update} />}
        />
      </Routes>
    </div>
  );
};

export default MainStudents;
